module.exports = __webpack_public_path__ + "img/Menu_Optimization.c08437c9.png";